import {combineReducers} from 'redux'
import {reducerCreator, makeActionCreator} from 'startlibs'
import {addItemReduce, updateItemReduce, deleteItemReduce, updateMergeReduce, updateOrderReduce, arrToMap} from './commonReducers'
import {ice} from 'icepath'

// const errorTest = {errors:{email:["It's an error!"]}}
export let store
export let postFetcher = () => Promise.resolve()
export const setStore = (newStore) => store = newStore
export const setFetcher = (newFetcher) => postFetcher = newFetcher

export const getReportId = () => {
  return store.getState().reportUID
}

export const getCommandType = (capitalized) => {
  if (getReportId())
    return (capitalized ? 'R':'r')+'eport'
  else
    return (capitalized ? 'S':'s')+'tudyNotes'
}

export const isStudyNotes = () => getCommandType()==='studyNotes'
export const isReport = () => getCommandType()==='report'


export const saveCompleteDocument = () => postFetcher(
  isReport() ? 'saveCompleteReport' : 'saveStudyNotes',
  isReport() ? storeStateToProps(store.getState()) :  saveStudyNotesProps(store.getState())
)

function saveStudyNotesProps(state) {
  return  studyNotesStateToProps({
    studyNotes: {
      fields:state.studyNotes.fields,
      basicInfos:state.studyNotes.basicInfos
    }
  })
}

let autoSaveQueue = []
let autoSaving = false
let nextAutoSavePromise = null
let savingQueue = []

const autoSave = (obj) => {
  autoSaveQueue.push(obj)
  return tryPost()
}

export const toggleRetryAutoSave = makeActionCreator('TOGGLE_AUTO_SAVE', (state, value) => ice(value))
const isRetryAutoSaveOpenReducer = reducerCreator(false, [toggleRetryAutoSave])
const updateDateReducer = () => ice(Date.now())
export const autoSaveUpdate = makeActionCreator('AUTO_SAVE_UPDATE', updateDateReducer, (object, {type}) => autoSave({
  object,
  type,
  method: 'update'
}))
export const autoSaveAll = makeActionCreator('AUTO_SAVE_ALL', updateDateReducer, (_, {type}) => autoSave({
  type,
  method: 'save_all'
}))
export const autoSaveRemove = makeActionCreator('AUTO_SAVE_REMOVE', updateDateReducer, (id, {type}) => autoSave({
  id,
  type,
  method: 'remove'
}))
export const autoSaveOrder = makeActionCreator('AUTO_SAVE_ORDER', updateDateReducer, (order, {type}) => autoSave({
  order,
  type,
  method: 'order'
}))

export const autoSaveRetry = makeActionCreator('AUTO_SAVE_RETRY', updateDateReducer, tryPost)
const lastSavedsReducer = reducerCreator(0, [autoSaveUpdate, autoSaveRemove, autoSaveOrder, autoSaveRetry])


function tryPost() {
  if (!autoSaving && autoSaveQueue.length) {
    autoSaving = true
    savingQueue = autoSaveQueue.slice()
    autoSaveQueue = []
    // const result = postFetcher('autoSave', savingQueue)
    const result = saveCompleteDocument()
    nextAutoSavePromise = result.then(() => {
      autoSaving = false
      savingQueue = []
      nextAutoSavePromise = null
      tryPost()
    })
    nextAutoSavePromise.catch((e) => {
      store.dispatch(toggleRetryAutoSave(true))
    })
    return result
  } else {
    return nextAutoSavePromise
  }
}

export const retryAutoSave = () => {
  autoSaving = false
  autoSaveQueue = savingQueue.concat(autoSaveQueue)
  store.dispatch(toggleRetryAutoSave(false))
  store.dispatch(autoSaveRetry())
}

// const getFetcher = (url)=> fetch(url,{method:"GET",credentials:"semi-origin"}).then(e=>e.json())

export const updateReportSettings = makeActionCreator('UPDATE_REPORT_SETTINGS', updateMergeReduce, (reportSettings) => postFetcher('saveSettings', reportSettings))
const reportSettingsReducer = reducerCreator({}, [updateReportSettings])

export const updateReportTitle = makeActionCreator('UPDATE_REPORT_TITLE', updateMergeReduce)
const reportTitleReducer = reducerCreator({}, [updateReportTitle])

const almostEmptyToEmpty = (s) => ((s||"").trim().replace(/^-$/,"").replace('\u200B',''))

export function testMerge(state,newListWithId,replaceDuplicates) {
  let modified = false
  const newList = newListWithId.map(_=>ice.unset(_,'id'))
  const compareContent = (a,b) => almostEmptyToEmpty(a) === almostEmptyToEmpty(b)
  const oldList = state.order
    .map((id, i) => state[id])
  const mergedBasicInfoPairs = oldList
    .map(old=> {
      const newItem = newList.find(_=>_.label === old.label)
      if (newItem && !compareContent(old.value,newItem.value) && !oldList.find(old => old.label === newItem.label && compareContent(old.value,newItem.value))) { modified = true }
      return [].concat(newItem || [],!newItem || (!replaceDuplicates && almostEmptyToEmpty(old.value) && !compareContent(old.value,newItem.value)) ? old : [])
    })
  const mergedBasicInfos = [].concat.apply([],mergedBasicInfoPairs)
  const isDuplicating = mergedBasicInfoPairs.length !== mergedBasicInfos.length
  const newNonRepeatedInfos = newList.filter(info => !oldList.find(old => old.label === info.label))
  modified = modified || newNonRepeatedInfos.length>0
  const result = mergedBasicInfos.concat(newNonRepeatedInfos).map(_=>_.value === '\u200B' ? ice.set(_,'value','') : _)
  return {modified,isDuplicating,result:normalize(result)}
}

function mergeItems(chain,newList,{replace}) {
  return ice(testMerge(chain.value(),newList,replace).result)
}

export const mergeReportBasicInfos = makeActionCreator('MERGE_REPORT_BASIC_INFO', mergeItems)
export const updateReportBasicInfo = makeActionCreator('UPDATE_REPORT_BASIC_INFO', updateItemReduce)
export const deleteReportBasicInfo = makeActionCreator('DELETE_REPORT_BASIC_INFO', deleteItemReduce)
export const addReportBasicInfo = makeActionCreator('ADD_REPORT_BASIC_INFO', addItemReduce)
export const updateReportBasicInfosOrder = makeActionCreator('UPDATE_REPORT_BASIC_INFOS_ORDER', updateOrderReduce)
const reportBasicInfosReducer = reducerCreator({}, [mergeReportBasicInfos, updateReportBasicInfo, addReportBasicInfo, deleteReportBasicInfo, updateReportBasicInfosOrder])

function isHtmlEmpty(html) {
  const el = document.createElement('div')
  el.innerHTML = html
  return el.textContent === ''
}

export const mergeReportFields = makeActionCreator('MERGE_REPORT_FIELD', mergeItems)
export const updateReportField = makeActionCreator('UPDATE_REPORT_FIELD', updateItemReduce)
export const deleteReportField = makeActionCreator('DELETE_REPORT_FIELD', deleteItemReduce)
export const addReportField = makeActionCreator('ADD_REPORT_FIELD', addItemReduce)
export const updateReportFieldsOrder = makeActionCreator('UPDATE_REPORT_FIELDS_ORDER', updateOrderReduce)
const reportFieldsReducer = reducerCreator({}, [mergeReportFields, updateReportField, addReportField, deleteReportField, updateReportFieldsOrder])

export const updateReportSignature = makeActionCreator('UPDATE_REPORT_SIGNATURE', updateItemReduce)
export const deleteReportSignature = makeActionCreator('DELETE_REPORT_SIGNATURE', deleteItemReduce)
export const addReportSignature = makeActionCreator('ADD_REPORT_SIGNATURE', addItemReduce)
export const updateReportSignaturesOrder = makeActionCreator('UPDATE_REPORT_SIGNATURES_ORDER', updateOrderReduce)
const reportSignaturesReducer = reducerCreator({}, [updateReportSignature, deleteReportSignature, addReportSignature, updateReportSignaturesOrder])

export const retryFailedReportKeyImages = makeActionCreator('RETY_FAILED_REPORT_KEY_IMAGES', (chain)=>chain.map((image=>image.uploadStatus==='failed'? ice.set(image,'uploadStatus','uploading') : image)))
export const updateReportKeyImage = makeActionCreator('UPDATE_REPORT_KEY_IMAGE', updateItemReduce)
export const deleteReportKeyImage = makeActionCreator('DELETE_REPORT_KEY_IMAGE', deleteItemReduce)
export const addReportKeyImage = makeActionCreator('ADD_REPORT_KEY_IMAGE', addItemReduce)
export const setReportKeyImage = makeActionCreator('SET_REPORT_KEY_IMAGE', (c,p) => ice(normalize(p)))
export const updateReportKeyImagesOrder = makeActionCreator('UPDATE_REPORT_KEY_IMAGES_ORDER', updateOrderReduce)
const reportKeyImagesReducer = reducerCreator({}, [updateReportKeyImage, retryFailedReportKeyImages, deleteReportKeyImage, addReportKeyImage, updateReportKeyImagesOrder])

export const addAvailableSignature = makeActionCreator('ADD_AVAILABLE_SIGNATURE', (chain, p, m) => addItemReduce(chain, p, m, 'signatureId'), (signature) => postFetcher('saveSignature', signature))
export const deleteAvailableSignature = makeActionCreator('DELETE_AVAILABLE_SIGNATURE', (chain, _, {_payload}) => chain.set([_payload,'disabled'],true), (signatureId) => postFetcher('deleteSignature', {signatureId}))
const availableSignaturesReducer = reducerCreator({}, [addAvailableSignature, deleteAvailableSignature])


export const updateStudyNotesBasicInfo = makeActionCreator('UPDATE_STUDY_NOTES_BASIC_INFO', updateItemReduce)
export const deleteStudyNotestBasicInfo = makeActionCreator('DELETE_STUDY_NOTES_BASIC_INFO', deleteItemReduce)
export const addStudyNotesBasicInfo = makeActionCreator('ADD_STUDY_NOTES_BASIC_INFO', addItemReduce)
export const updateStudyNotesBasicInfosOrder = makeActionCreator('UPDATE_STUDY_NOTES_BASIC_INFOS_ORDER', updateOrderReduce)
const studyNotesBasicInfosReducer = reducerCreator({}, [updateStudyNotesBasicInfo, deleteStudyNotestBasicInfo, addStudyNotesBasicInfo, updateStudyNotesBasicInfosOrder])

export const updateStudyNotesField = makeActionCreator('UPDATE_STUDY_NOTES_FIELD', updateItemReduce)
export const deleteStudyNotesField = makeActionCreator('DELETE_STUDY_NOTES_FIELD', deleteItemReduce)
export const addStudyNotesField = makeActionCreator('ADD_STUDY_NOTES_FIELD', addItemReduce)
export const updateStudyNotesFieldsOrder = makeActionCreator('UPDATE_STUDY_NOTES_FIELDS_ORDER', updateOrderReduce)
const studyNotesFieldsReducer = reducerCreator({}, [updateStudyNotesField, deleteStudyNotesField, addStudyNotesField, updateStudyNotesFieldsOrder])


const identityReducer = (initalState) => (state = initalState, action) => state

export const changeTemplate = makeActionCreator('CHANGE_TEMPLATE', (state) => state, (templateId) => postFetcher('changeTemplate', {templateId}))
export const deleteTemplate = makeActionCreator('DELETE_TEMPLATE',
  (chain,_,{_payload:{templateId}}) => chain.update('available', _ => _.filter(_=>_.templateId !== templateId)),
  ({templateId}) => postFetcher('deleteTemplate', {templateId})
)

export const renameTemplate = makeActionCreator('RENAME_TEMPLATE',
  (chain,_,{_payload:{templateId,label}}) => chain.update('available',_ => _.map(_=>_.templateId !== templateId ? _ : {templateId,label})),
  (templObj) => postFetcher('renameTemplate', templObj)
)
export const saveTemplate = makeActionCreator(
  'SAVE_TEMPLATE',
  (chain, {templateId:tid, id, label}) => {
    //fix swagger
    const templateId = tid || id
    return chain.set('selected',templateId).update('available',_=>_.find(t => String(t.templateId) === String(templateId)) ? _ : _.concat([{templateId, label}]))
  },
  (obj) => postFetcher('saveTemplate', obj)
)
const templatesReducer = reducerCreator({}, [saveTemplate,renameTemplate,deleteTemplate])

export const finishDocument = makeActionCreator('FINISH_DOCUMENT', (chain, {finished}) => ice(Date.now()), () => postFetcher('finish'+getCommandType(true), {}))
export const unfinishDocument = makeActionCreator('UNFINISH_DOCUMENT', () => ice(0), () => postFetcher('unfinish'+getCommandType(true), {}))
const finishedReducer = reducerCreator(false, [finishDocument, unfinishDocument])

export const lockStudyNotes = makeActionCreator('LOCK_STUDY_NOTES', (chain, {locked}) => ice(locked), () => postFetcher('lockStudyNotes', {},'studyNotes'))
export const unlockStudyNotes = makeActionCreator('UNLOCK_STUDY_NOTES', () => ice(0), () => postFetcher('unlockStudyNotes', {},'studyNotes'))
const lockedReducer = reducerCreator(false, [lockStudyNotes, unlockStudyNotes])

export const togglePreview = makeActionCreator('TOGGLE_PREVIEW', (chain,v) => chain.update(_=>typeof v !== "boolean" ? !_:v))
const isPreviewingReducer = reducerCreator(false, [togglePreview])


export const imagesLoaded = makeActionCreator('IMAGES_LOADED', (chain, _, {_payload}) => ice(_payload))
const imagesLoadedReducer = reducerCreator(false, [imagesLoaded])

export const toggleGlobal = makeActionCreator("TOGGLE_GLOBAL", (chain, _, {newValue,_payload}) => chain.set(_payload,newValue === undefined ? !chain.get(_payload).value() : newValue))
const toggleReducer = reducerCreator({}, [toggleGlobal])


function mergeTemplateBasicInfos(oldBasicInfoState,newBasicInfo,dicomInfo) {
  const modifiedOldBasicInfo = oldBasicInfoState.order.map((id, i) => oldBasicInfoState[id])
    .filter(info => !!info.value && dicomInfo[info.dicomField] !== info.value)
  const oldNotOnNew = modifiedOldBasicInfo.filter(info => !newBasicInfo.find(newInfo => info.label === newInfo.label))

  const newMappedWithOldAndDicom = newBasicInfo.map(info => {
    const existingInfo = modifiedOldBasicInfo.filter(old => old.label === info.label && old.value !== info.value)
    return (existingInfo.length ? existingInfo : [{...info, value: dicomInfo[info.dicomField] || ''}])
  })
  const result = [].concat.apply([], newMappedWithOldAndDicom).concat(oldNotOnNew)
  return normalize(result)
}

function mergeTemplateFields(oldFieldsState,newFields) {
  const modifiedOldFields = oldFieldsState.order.map((id, i) => oldFieldsState[id])
    .filter(field => !!field.value && field.modified)
  const oldNotOnNew = modifiedOldFields.filter(field => !newFields.find(newField => field.label === newField.label))
  const combinedNewMappedWithOld = newFields.map(field => {
    const existingFields = modifiedOldFields.filter(old => old.label === field.label && old.value !== field.value)
    return (existingFields.length ? (isHtmlEmpty(field.value) ? [] : [field]).concat(existingFields) : [field])
  })
  const result = [].concat.apply([], combinedNewMappedWithOld).concat(oldNotOnNew)
  return normalize(result)
}

function mergeTemplateSignatures(oldSignatureState,newSignatures,availableSignatures) {
  const ownerSignature = (availableSignatures.filter(s => s.owner)[0] || {})
  const newOwnerSignature = newSignatures.filter(s => s.signatureId === ownerSignature.signatureId)

  const customSignatures = oldSignatureState.order.map(id => oldSignatureState[id]).filter(signature => signature.isCustom)
  const newSignaturesWithoutCustom = newSignatures.filter(s =>
    s.signatureId !== ownerSignature.signatureId &&
    !customSignatures.find(old => old.signatureId === s.signatureId)
  )
  return normalize([...newOwnerSignature, ...newSignaturesWithoutCustom, ...customSignatures])
}

export const reportReducersCreator = ({appUI}) => combineReducers({
  reportSettings: reportSettingsReducer(),
  reportTitle: reportTitleReducer({
    [changeTemplate]: (chain, {reportTitle}) => chain.assign(reportTitle)
  }),
  reportBasicInfos: reportBasicInfosReducer({
    // os antigos embaixo
    [changeTemplate]: (chain, {reportBasicInfos}, {dicomInfo}) =>
      isReport() ? ice(mergeTemplateBasicInfos(chain.value(),reportBasicInfos,dicomInfo)) : chain
  }),
  reportFields: reportFieldsReducer({
    // combine same name, os antigos embaixo
    [changeTemplate]: (chain, {reportFields}) =>
      isReport() ? ice(mergeTemplateFields(chain.value(),reportFields)) : chain
  }),
  reportSignatures: reportSignaturesReducer({
    // self user primeiro, depois do template, os antigos por ultimo
    [changeTemplate]: (chain, {reportSignatures}, {availableSignatures,...rest}) =>
      isReport() ? ice(mergeTemplateSignatures(chain.value(),reportSignatures,availableSignatures)) : chain
  }),
  reportKeyImages: reportKeyImagesReducer(),
  availableSignatures: availableSignaturesReducer(),
  templates: templatesReducer({
    [changeTemplate]: (chain, _, {_payload}) => chain.set('selected',_payload)
  }),
  finished: finishedReducer(),
  worklistSourcePage: identityReducer(''),
  dicomInfo: identityReducer({}),
  userEmail: identityReducer(''),
  reportUID: identityReducer(null),
  isPdfPrinter: identityReducer(false),
  invalidLink: identityReducer(false),
  readOnly: identityReducer(false),
  sharedReportViewPHIAuthenticationRequired:identityReducer(false),
  sharedReportView:identityReducer(false),
  fax: identityReducer({enabled:false}),
  navigationDisabled: identityReducer(false),
  attachedReport: identityReducer(false),
  resourceOrigin: identityReducer(''),
  pdfrenderer: identityReducer({
    'reportRendererEndpoint': 'http://vivareports.vivacloud.io:1337/',
    'reportLoaderEnpoint': 'http://vivareports.vivacloud.io/report.php'
  }),
  lastSaved: lastSavedsReducer({
    [changeTemplate]: updateDateReducer,
    [updateReportSettings]: updateDateReducer,
    [finishDocument]: updateDateReducer,
    [unfinishDocument]: updateDateReducer
  }),
  isPreviewOpen: isPreviewingReducer({
    [unfinishDocument]: () => ice(false),
    [finishDocument]: () => ice(false)
  }),
  imagesLoaded: imagesLoadedReducer(),
  appUI: appUI({
    retryAutoSave: isRetryAutoSaveOpenReducer(),
    toggles:toggleReducer()
  }),
  studyNotes: combineReducers({
    finished: identityReducer(false),
    lastSaved: identityReducer(0),
    uid: identityReducer(null),
    locked: lockedReducer(),
    editedBy: identityReducer(""),
    basicInfos: studyNotesBasicInfosReducer({
      [changeTemplate]:(chain,{studyNotes},{dicomInfo}) =>
        isStudyNotes() ? ice(mergeTemplateBasicInfos(chain.value(),studyNotes.basicInfos,dicomInfo)) : chain
    }),
    fields: studyNotesFieldsReducer({
      [changeTemplate]:(chain,{studyNotes}) =>
        isStudyNotes() ? ice(mergeTemplateFields(chain.value(),studyNotes.fields)) : chain
    })
  }),
  reportRecipients:identityReducer({})
})

export const reportReducers = reportReducersCreator({appUI:combineReducers})

export const LOAD_REPORT = 'LOAD_REPORT'
export const SET_STUDY_NOTES = 'SET_STUDY_NOTES'

export const rootReducer = (state, action) => {
  if (action.type === LOAD_REPORT) {
    state = {...state, isPreviewOpen: true, ...propsToStoreState(action.payload)}
  }
  if (action.type === SET_STUDY_NOTES) {
    state = {...state, studyNotes: studyNotesPropsToStoreState(action.payload.studyNotes,state.dicomInfo)}
  }
  return reportReducers(state, action)
}

function fixStudies(dicomInfo) {
  if (dicomInfo.studies && dicomInfo.studies.length) { return dicomInfo }
  return {...dicomInfo,studies:[{title:dicomInfo.studydesc,date:dicomInfo.studydate}]}
}

const formattableDicomDates = ['dob','studydate']

export function propsToStoreState(props) {
  const {reportBasicInfos,  reportRecipients, reportTitle, reportFields, reportSignatures, availableSignatures, dicomInfo,studyNotes, ...unchanged} = props
  const applyDicomFields = !(reportBasicInfos||[]).find(_=>_.dicomField && almostEmptyToEmpty(_.value)!== "")
  return {
    ...unchanged,
    reportRecipients: reportRecipients || {suggestedUsers:[],registeredUsers:[]},
    dicomInfo:fixStudies(dicomInfo),
    reportTitle: {
      ...reportTitle,
      date: reportTitle && (reportTitle.date || Date.now())
    },
    reportBasicInfos: normalize((reportBasicInfos || []).map(info => ({
      ...info,
      value: (info.value || (applyDicomFields ? (formattableDicomDates.indexOf(info.dicomField)<0  ? dicomInfo[info.dicomField] || '' : '\u200B') : ""))
    }))),
    lastSaved: props.finished ? props.lastSaved : Date.now(),
    reportKeyImages: normalize(props.reportKeyImages||[]),
    reportFields: normalize(reportFields||[]),
    reportSignatures: normalize(reportSignatures||[]),
    availableSignatures: {
      ...arrToMap(availableSignatures||[], 'signatureId'), order: (availableSignatures||[]).map(r => r.signatureId)
    },
    ...studyNotesToDocumentProps(props),
    studyNotes:studyNotesPropsToStoreState(studyNotes,dicomInfo)
  }
}

function studyNotesToDocumentProps({reportUID,studyNotes}) {
  if (reportUID) return {}
  return {
    lastSaved: studyNotes.finished ? studyNotes.lastSaved : Date.now(),
    finished: studyNotes.finished
  }
}

export function studyNotesPropsToStoreState(studyNotes,dicomInfo) {
  return {
    ...studyNotes,
    basicInfos:normalize((studyNotes ? studyNotes.basicInfos || [] : []).map(info => ({
      ...info,
      value: (info.value || (formattableDicomDates.indexOf(info.dicomField)<0 ? dicomInfo[info.dicomField] || '' : '\u200B'))
    }))),
    fields:normalize(studyNotes ? studyNotes.fields || [] : [])
  }
}



let uid = 1

function normalize(list) {
  const withId = list.map(i => ({...i, id: i.id || uid++}))
  return {...arrToMap(withId), order: withId.map(i => i.id)}
}

export function storeStateToProps(state) {
  const withoutId = ({id, ...obj}) => obj
  const mapToArray = (obj) => obj.order.map(k => withoutId(obj[k]))
  const {reportSettings, reportUID, reportBasicInfos, reportKeyImages, reportTitle, reportFields, reportSignatures, availableSignatures, dicomInfo, templates, lastSaved, finished} = state
  return {
    reportUID,
    reportSettings: reportSettings,
    reportBasicInfos: mapToArray(reportBasicInfos),
    reportFields: mapToArray(reportFields),
    reportSignatures: mapToArray(reportSignatures),
    reportKeyImages: mapToArray(reportKeyImages).filter(_=>!_.uploadStatus),
    availableSignatures: mapToArray(availableSignatures),
    reportTitle, dicomInfo, templates, lastSaved, finished
  }
}
export function studyNotesStateToProps(state) {
  const withoutId = ({id, ...obj}) => obj
  const mapToArray = (obj) => obj.order.map(k => withoutId(obj[k]))
  const {studyNotes} = state
  return {
    studyNotes: {
      ...studyNotes,
      fields: mapToArray(studyNotes.fields),
      basicInfos: mapToArray(studyNotes.basicInfos)
    }
  }
}




// WEBPACK FOOTER //
// ./~/report-components/src/reducers/index.js